import Tabby from 'tabbyjs';

export default function initTabs() {
  const tabContainers = document.querySelectorAll('[data-tabs]');
  if (!tabContainers.length) return;

  tabContainers.forEach((container, index) => {
    const tabsId = container.getAttribute('data-tabs') || `tabs-${index}`;
    container.setAttribute('data-tabs', tabsId);

    const tabsWrapper = container.closest('.tabs');
    if (!tabsWrapper) return;

    const tabContents = tabsWrapper.querySelectorAll('.tabs-content');
    if (!tabContents.length) return;
    const tabLinks = container.querySelectorAll('a[href^="#"]');
    const tabsWrap = tabsWrapper.querySelector('.tabs-wrap');
    const mapElement = tabsWrapper.closest('.map-row')?.querySelector('#map-custom');
    const isLocationMapTabs = tabsWrapper.classList.contains('map-filters') && container.classList.contains('location-list');
    const isEnhancedLocationMapTabs = isLocationMapTabs && mapElement?.dataset.mapMode === 'all-regions';

    let isAllLocationsMode = false;

    new Tabby(`[data-tabs="${tabsId}"]`);

    const getHashTargetId = () => {
      if (!isEnhancedLocationMapTabs) return null;

      const rawHash = window.location.hash.replace('#', '').trim().toLowerCase();
      if (!rawHash) return null;

      for (const tabLink of tabLinks) {
        const targetId = tabLink.getAttribute('href')?.replace('#', '').trim().toLowerCase();
        if (!targetId) continue;

        const shortId = targetId.replace(/-tabs$/, '');
        if (rawHash === targetId || rawHash === shortId) {
          return `#${targetId}`;
        }
      }

      return null;
    };

    const clearTabButtonsState = () => {
      tabLinks.forEach((link) => {
        link.classList.remove('active');
        link.setAttribute('aria-selected', 'false');
      });
    };

    const setShowAllLocationsMode = () => {
      if (!isEnhancedLocationMapTabs) return;

      isAllLocationsMode = true;
      clearTabButtonsState();

      tabContents.forEach((content) => {
        content.classList.add('is-active');
        content.removeAttribute('hidden');
        content.style.height = 'auto';
      });

      if (tabsWrap) {
        tabsWrap.style.height = 'auto';
      }
    };

    const clearShowAllLocationsMode = () => {
      if (!isAllLocationsMode) return;
      isAllLocationsMode = false;
    };

    const updateLocationHash = (targetId) => {
      if (!isEnhancedLocationMapTabs) return;

      const hashValue = targetId.replace('#', '').replace(/-tabs$/, '').toLowerCase();
      const url = `${window.location.pathname}${window.location.search}#${hashValue}`;
      window.history.replaceState(null, '', url);
    };

    const updateTabsWrapHeight = () => {
      if (isEnhancedLocationMapTabs && isAllLocationsMode) {
        if (tabsWrap) tabsWrap.style.height = 'auto';
        return;
      }

      const activeContent = tabsWrapper.querySelector('.tabs-content.is-active');

      if (activeContent && tabsWrap) {
        const newHeight = activeContent.scrollHeight;
        tabsWrap.style.height = `${newHeight}px`;
      }
    };

    let resizeTimeout;
    const handleResize = () => {
      updateTabsWrapHeight();
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(updateTabsWrapHeight, 150);
    };

    window.addEventListener('resize', handleResize);

    requestAnimationFrame(() => {
      const hashTargetId = getHashTargetId();
      const defaultTab = container.querySelector('[data-tabby-default]');
      const defaultTargetId = defaultTab ? defaultTab.getAttribute('href') : null;
      const initialTargetId = hashTargetId || defaultTargetId;
      const defaultContent = initialTargetId ? tabsWrapper.querySelector(initialTargetId) : tabContents[0];

      tabContents.forEach((content) => {
        content.style.height = '0';
        content.classList.remove('is-active');
      });

      if (isEnhancedLocationMapTabs && !hashTargetId) {
        setShowAllLocationsMode();
        return;
      }

      if (defaultContent) {
        defaultContent.classList.add('is-active');
        const newHeight = defaultContent.scrollHeight;
        defaultContent.style.height = `${newHeight}px`;

        if (tabsWrap) {
          tabsWrap.style.height = `${newHeight}px`;
        }
      }

      if (hashTargetId) {
        const hashTargetTab = container.querySelector(`a[href="${hashTargetId}"]`);
        hashTargetTab?.click();
      }
    });

    const setTabHeight = (content, wrap) => {
      const newHeight = content.scrollHeight;
      content.style.height = `${newHeight}px`;
      if (wrap) wrap.style.height = `${newHeight}px`;
    };

    const resetTabHeight = (content) => {
      content.style.height = '0';
      content.classList.remove('is-active');
    };

    document.addEventListener('tabby', (event) => {
      if (!container.contains(event.target)) return;

      const targetId = event.target.getAttribute('href');
      if (!targetId) return;

      const targetContent = tabsWrapper.querySelector(targetId);
      const currentActive = tabsWrapper.querySelector('.tabs-content.is-active');

      if (!targetContent) return;

      updateLocationHash(targetId);

      if (isEnhancedLocationMapTabs && isAllLocationsMode) {
        tabContents.forEach((content) => {
          if (content === targetContent) return;
          resetTabHeight(content);
        });
        clearShowAllLocationsMode();
      }

      if (currentActive && currentActive !== targetContent) {
        resetTabHeight(currentActive);
      }

      targetContent.classList.add('is-active');
      setTabHeight(targetContent, tabsWrap);

      // processing sliders
      const sliders = targetContent.querySelectorAll('.slick-slider');
      sliders.forEach((slider) => {
        const $slider = jQuery(slider);
        if ($slider.hasClass('slick-initialized')) {
          $slider.slick('setPosition');
        }
      });

      // mobile select
      if (window.innerWidth < 1024) {
        const select = jQuery('.select-study-modes').eq(index);
        if (select.length) select.val(targetId.substring(1)).trigger('change');
      }
    });

    if (isEnhancedLocationMapTabs) {
      window.addEventListener('hashchange', () => {
        const hashTargetId = getHashTargetId();

        if (!hashTargetId) {
          setShowAllLocationsMode();
          return;
        }

        const hashTargetTab = container.querySelector(`a[href="${hashTargetId}"]`);
        hashTargetTab?.click();
      });
    }
  });
}
